import { UserCommand } from './UserCommand';
import { CreateUserCommand } from './CreateUserCommand';
import { RevenueCommand } from './RevenueCommand';
import { SearchCommand } from './SearchCommand';
import { BaseCommand } from './BaseCommand';

function ArrayEquals(a: string[], b: string[]): boolean {
  if (a.length != b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] != b[i]) {
      return false;
    }
  }
  return true;
}

export class Parser {
  private tokens: any[];
  private position: number;

  constructor(tokens: any[]) {
    this.tokens = tokens;
    this.position = 0;
  }

  instantiateOptions(token: any): BaseCommand[] {
    if (!token) {
      return [];
    }
    if (token.type !== 'command' && token.type !== 'command-part') {
      throw new Error(`Invalid command: ${this.getInput()}`);
    }
    const tokenOptions: string[][] = token.commands;

    const allCommands: BaseCommand[] = [
      new CreateUserCommand(),
      new UserCommand(),
      new RevenueCommand(),
      new SearchCommand(),
    ];
    return allCommands.filter((cmd) =>
      tokenOptions.some((tokenOption) => ArrayEquals(tokenOption, cmd.getKeywords())),
    );
  }

  parse(): BaseCommand[] {
    let options = this.instantiateOptions(this.tokens[0]);

    while (this.position < this.tokens.length) {
      const token = this.tokens[this.position];
      let newOptions: BaseCommand[] = [];
      switch (token.type) {
        case 'command':
          for (const cmd of options) {
            if (cmd.isPartExpected(token.value, token.isPartial)) {
              cmd.add(token.value, token.isPartial);
              newOptions.push(cmd);
            }
          }
          options = newOptions;
          break;
        case 'command-part':
          for (const cmd of options) {
            if (cmd.isPartExpected(token.value, token.isPartial)) {
              cmd.add(token.value, token.isPartial);
              newOptions.push(cmd);
            }
          }
          options = newOptions;
          break;
        case 'parameter':
          if (options.length == 0) {
            throw new Error(`Invalid command: ${this.getInput()}`);
          }
          for (const cmd of options) {
            cmd['parameters'].push(token.value);
          }
          break;
      }
      this.position++;
    }
    return options;
  }

  getInput(): string {
    return this.tokens.map((token: any) => token.value).join(' ');
  }
}
